module.exports = __webpack_public_path__ + "static/media/abstract1.cbac1cd8.svg";